import BaseForm from '../base';
import { ObjectPanelComponent, LatLongColumnsComponent } from '../components';
export class TicketingSwdForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent({ validate: { required: true } }),
            new ObjectPanelComponent({
                label: 'Site',
                key: 'site',
                components: [
                    {
                        label: 'Contact Name',
                        key: 'contactName',
                        type: 'textfield',
                    },
                    {
                        label: 'Contact Phone',
                        key: 'contactPhone',
                        type: 'textfield',
                    },
                    {
                        label: 'Name',
                        key: 'name',
                        type: 'textfield',
                    },
                    {
                        label: 'Company Name',
                        key: 'companyName',
                        type: 'textfield',
                    },
                ]
            }),
            {
                label: 'Lanes',
                key: 'lanes',
                type: 'datagrid',
                reorder: false,
                defaultValue: [
                    {}
                ],
                components: [
                    {
                        label: 'Lane',
                        title: 'Lane',
                        key: 'lanes-Panel',
                        type: 'panel',
                        components: [
                            {
                                label: 'ID',
                                key: 'id',
                                type: 'number',
                            },
                            {
                                label: 'Name',
                                key: 'name',
                                type: 'textfield',
                            },
                            {
                                label: 'Printer',
                                key: 'printer',
                                type: 'number',
                            },
                            {
                                label: 'Snapshot Camera IDs',
                                key: 'snapshots',
                                type: 'textfield',
                                multiple: true,
                            }
                        ]
                    }
                ]
            },
            {
                label: 'Printers',
                key: 'printers',
                type: 'datagrid',
                reorder: false,
                defaultValue: [
                    {}
                ],
                components: [
                    {
                        label: 'Printer',
                        title: 'Printer',
                        key: 'printers-Panel',
                        type: 'panel',
                        components: [
                            {
                                label: 'ID',
                                key: 'id',
                                type: 'number',
                            },
                            {
                                label: 'IP',
                                key: 'ip',
                                type: 'textfield',
                            },
                            {
                                label: 'Port',
                                key: 'port',
                                type: 'number',
                            },
                        ]
                    }
                ]
            },
            new ObjectPanelComponent({
                label: 'PLC',
                key: 'plc',
                components: [
                    {
                        label: 'IP',
                        key: 'ip',
                        type: 'textfield',
                    }
                ]
            }),
            {
                label: 'Resources',
                key: 'resources',
                type: 'datagrid',
                reorder: false,
                defaultValue: [
                    {}
                ],
                components: [
                    {
                        label: 'Resource',
                        title: 'Resource',
                        key: 'resources-Panel',
                        type: 'panel',
                        components: [
                            {
                                label: 'Name',
                                key: 'name',
                                type: 'textfield',
                            },
                            new ObjectPanelComponent({
                                label: 'Criteria',
                                key: 'criteria',
                                components: [
                                    {
                                        label: 'Data District',
                                        key: 'data.district',
                                        type: 'textfield',
                                    }
                                ]
                            })
                        ]
                    }
                ]
            }
        ];
    }
}
